import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { EntityOrderedRequestParameters, MessageChannelService, messageLevel } from '@bndes/bndes-ux4/bndes-angular-utils';
import { BnModalMessageService } from '@bndes/bndes-ux4/bn-modal-message';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import Utils from 'src/app/shared/fgi-utils';
import { RenunciaLimiteAdicional } from 'src/app/model/renuncia-limite-adicional.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RenunciaLimiteAdicionalService } from '../renuncia-limite-adicional.service';

@Component({
  selector: 'app-renuncia-limite-adicional-listagem',
  templateUrl: './listagem.component.html',
  styleUrls: ['./listagem.component.scss'],
  standalone: false,
})
export class ListagemComponent implements OnInit {

  @Input() public renuncias: RenunciaLimiteAdicional[] = [];

  @Output() public renunciaExcluida: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('modalExclusao') modalExclusao: TemplateRef<any>;
  @ViewChild('botoesModalExclusao') botoesModalExclusao: TemplateRef<any>;

  public atributosOrdenacao: EntityOrderedRequestParameters;

  public perfilAdmTransacional = false;

  private ideRenunciaAExcluir: number;

  constructor(
    private service: RenunciaLimiteAdicionalService,
    private permissaoService: PermissaoService,
    private messageService: MessageChannelService,
    private modalService: BnModalMessageService,
  ) {}

  ngOnInit() {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.perfilAdmTransacional = resp && resp[ROLE_GESTOR_ENVIO];
    });

    if (!this.atributosOrdenacao) {
      this.atributosOrdenacao = {
        atributo: 'nomeAgenteFinanceiro',
        sentido: 'asc'
      } as EntityOrderedRequestParameters;
    }
  }

  public exibeListagem(): boolean {
    return this.renuncias && this.renuncias.length > 0;
  }

  public exibeColunaAcoes(): boolean {
    return this.perfilAdmTransacional;
  }

  public podeExcluir(renuncia: RenunciaLimiteAdicional): boolean {
    return this.perfilAdmTransacional && renuncia?.permiteExclusao;
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.renuncias = this.renuncias.sort((a, b) => {
      if (ord.sentido == 'asc') {
        return Utils.comparaComFuncao(a, b, ord.atributo, undefined);
      }

      return -1 * Utils.comparaComFuncao(a, b, ord.atributo, undefined);
    });
  }

  public abrirModalConfirmarExclusao(renuncia: RenunciaLimiteAdicional) {
    if (!this.podeExcluir(renuncia)) {
      return;
    }

    this.ideRenunciaAExcluir = renuncia.ide;

    const modal = this.modalService.abrir('Confirmação', null, 'md', this.modalExclusao, this.botoesModalExclusao);
    modal.result.finally(() => this.ideRenunciaAExcluir = null);
  }

  public fecharModalExclusao() {
    this.modalService.dismiss('abortou a exclusão da solicitação de renúncia');
  }

  public confirmarExclusao() {
    const ideRenuncia = this.ideRenunciaAExcluir;

    this.modalService.dismiss('confirmou a exclusão da solicitação de renúncia');

    this.service.excluir(ideRenuncia).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Solicitação de renúncia excluída.'
      });

      this.renunciaExcluida.emit();
    });
  }
}
